// extracted by mini-css-extract-plugin
module.exports = {"headingDefaults":"_2yMOH","ellipsis":"R0DEt"};